import { createSystem, defaultConfig } from '@chakra-ui/react';
import { Provider as Chakra } from '@/components/ui/provider';

import generateColorShades from '../_utils/generateColorShades';
import { useMemo } from 'react';
import { COLORS } from '../_theme';

export default function ThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const color =
    // useSelector((state: IRedux) => state.settings?.data?.data?.color) ||
    '#ED3237';

  const shades = generateColorShades(color);

  const tokenColors = useMemo(() => {
    return {
      background: {
        card: { value: '#fff' },
        DEFAULT: { value: '#F5F4F3' },
      },
      primary: {
        ...shades,
        DEFAULT: { value: color },
        hover: { value: color + 'dd' },
        text: { value: '#FFFFFF' },
      },
      product_button: {
        DEFAULT: { value: '#F3F3F3' },
        hover: { value: '#FAF7F7' },
        text: { value: '#475467' },
      },
      text: {
        DEFAULT: { value: '#09090b' },
        muted: { value: '#a1a1aa' },
      },
      promo: { value: '#16A34A' },
      price: { value: color },
    };
  }, [color]);

  const system = createSystem(defaultConfig, {
    theme: {
      tokens: {
        colors: {
          ...tokenColors,
          ...COLORS,
          brand: {
            solid: { value: '{colors.primary.500}' },
            contrast: { value: '{colors.primary.100}' },
            fg: { value: '{colors.primary.400}' },
            muted: { value: '{colors.primary.100}' },
            subtle: { value: '{colors.primary.50}' },
            emphasized: { value: '{colors.primary.300}' },
            focusRing: { value: '{colors.primary.500}' },
          },
        },
      },
      semanticTokens: {
        colors: {
          semanticTokens: {
            colors: {
              bg: {
                card: { value: '{colors.background.card}' },
                default: { value: '{colors.background}' },
              },
              text: {
                default: { value: '{colors.text}' },
                muted: { value: '{colors.text.muted}' },
              },
              button: {
                primary: { value: '{colors.product_button}' },
                primaryHover: { value: '{colors.product_button.hover}' },
                primaryText: { value: '{colors.product_button.text}' },
              },
            },
          },
        },
      },
    },
    globalCss: {
      ':root': {
        '--primary-default': tokenColors?.primary?.DEFAULT?.value,
        '--primary-hover': tokenColors?.primary?.hover?.value,
        '--primary-text': tokenColors?.primary?.text?.value,
        '--bg-default': tokenColors?.background?.DEFAULT?.value,
        '--bg-card': tokenColors?.background?.card?.value,
        '--product-btn-default': tokenColors?.product_button?.DEFAULT?.value,
        '--product-btn-hover': tokenColors?.product_button?.hover?.value,
        '--product-btn-text': tokenColors?.product_button?.text?.value,
        '--text-default': tokenColors?.text?.DEFAULT?.value,
        '--text-muted': tokenColors?.text?.muted?.value,
        '--promo': tokenColors?.promo?.value,
        '--price': tokenColors?.price?.value,
        '--rate-color': '#FFB338',
        '--gray-color-300': '#F3F3F3',
        '--gray-color-400': '#EDEDED',
        '--gray-color-500': '#CDCDCD',
        '--gray-color-600': '#676767',
        '--gray-color-700': '#667085',
        '--gray-color-800': '#475467',
      },
    },
  });

  return (
    <div>
      <Chakra system={system} props={{ forcedTheme: 'light' }}>
        {children}
      </Chakra>
    </div>
  );
}
